import { CommonSectionIds } from "../common.models";


export const GenericSectionids = {
    BasicInfo: CommonSectionIds.BasicInfo,
    DialogActions: CommonSectionIds.DialogActions,
}